import { OTP_DELIVERY_CHANNELS } from '../../../../../services/exports/Constants';

export default {
  form: {
    phone_number: {
      label: 'Número de teléfono',
      placeholder: 'Introduce el número de teléfono',
    },
    email: {
      label: 'Correo electrónico',
      placeholder: 'Introduce el correo electrónico',
    },
  },
  channel_chooser: {
    title: 'Enviar código por',
    [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
      label: 'WhatsApp',
      subtitle: 'Gratis, entrega más rápida',
    },
    [OTP_DELIVERY_CHANNELS.SMS]: {
      label: 'SMS',
      subtitle: 'Mensaje de texto estándar',
    },
    [OTP_DELIVERY_CHANNELS.EMAIL]: {
      label: 'Correo electrónico',
      subtitle: 'El código directo a tu bandeja de entrada',
    },
  },
  otp: {
    title: 'Introduce el código de verificación',
    send_code: 'Enviar código',
    sent_via: {
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Enviado por <strong>WhatsApp</strong> a <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.SMS]: 'Enviado por <strong>SMS</strong> a <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Enviado por <strong>correo electrónico</strong> a <strong>{{phone}}</strong>',
    },
    sent_to: 'Enviado a',
    resend: {
      title: '¿No recibiste el código?',
      countdown: 'Reenviar en',
      options: {
        [OTP_DELIVERY_CHANNELS.EMAIL]: {
          title: '¿No recibiste el código por correo electrónico?',
          button: 'Reenviar por correo electrónico',
        },
        [OTP_DELIVERY_CHANNELS.SMS]: {
          title: '¿No recibiste el código?',
          button: 'Reenviar por SMS',
        },
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
          title: '¿No recibiste el código?',
          button: 'Reenviar por WhatsApp',
        },
      },
      switch: {
        [OTP_DELIVERY_CHANNELS.SMS]: 'Enviar por SMS en su lugar',
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Enviar por WhatsApp en su lugar',
      },
    },
    text: {
      [OTP_DELIVERY_CHANNELS.SMS]:
        'Se ha enviado un mensaje con un código de verificación a tu teléfono. Introduce el código para continuar.',
      [OTP_DELIVERY_CHANNELS.EMAIL]:
        'Por favor, introduce el código enviado a esta dirección: <br/> <strong>{{address}}</strong>',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]:
        'Se ha enviado un mensaje de WhatsApp con un código de verificación a tu teléfono. Introduce el código para continuar.',
    },
    tip: {
      [OTP_DELIVERY_CHANNELS.SMS]: '',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Consejo: revisa tu bandeja de entrada y tu carpeta de spam.',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: '',
    },
  },
  sender_note: {
    disclaimer: 'Aviso — el código se envía desde <strong>{{sender}}</strong>, nuestro socio tecnológico.',
    business_account: 'Cuenta empresarial',
    message: '<strong>123456</strong> es tu código de verificación. Por tu seguridad, no compartas este código.',
  },
  error_messages: {
    frequent_requests:
      'Por favor, revisa tus mensajes. Ya hemos enviado el código al número indicado. Si no lo recibiste, verifica el número de teléfono o inténtalo de nuevo en 10 minutos.',
    frequent_requests_email:
      'Revisa tu bandeja de entrada y la carpeta de spam. Ya hemos enviado el código a esa dirección. Si no ha llegado, inténtalo de nuevo en 10 minutos.',
    invalid_number: 'Número no válido. Por favor, inténtalo de nuevo.',
    invalid_email: 'No pudimos enviar el código a ese correo electrónico. Compruébalo e inténtalo de nuevo.',
    email_not_on_file:
      'Este número de teléfono ya tiene una cuenta sin correo electrónico. Contacta a {{support_email}} para añadir uno — hasta entonces no podremos enviar códigos para este número por correo electrónico.',
    turnstile_required: 'Por favor, completa la verificación antes de solicitar un nuevo código.',
    generic_error: 'Vaya, algo salió mal. Por favor, actualiza la página e inténtalo de nuevo.',
    change_phone_number_unsuccessful: 'No se pudo cambiar el número de teléfono. Por favor, inténtalo de nuevo.',
  },
  toasts: {
    code_sent: 'Código enviado',
  },
};
